/**
 * @deprecated Use src/api/client.js (apiClient) instead.
 *
 * This file is kept for backward compatibility with legacy pages that import
 * authInterceptor directly (home.js, bills.js, planning.js, etc.).
 * Those pages will be replaced by feature modules in TASK-07/09/12/14/16/18,
 * at which point this file can be deleted.
 *
 * Changes from the original:
 *   - baseURL now reads from REACT_APP_API_BASE_URL env var (was hardcoded).
 *   - Removed console.log of the refresh payload.
 */
import axios from "axios";
import jwt_decode from "jwt-decode";
import dayjs from "dayjs";
import { getCookie } from "../../utils/cookies.js";

const baseURL = process.env.REACT_APP_API_BASE_URL || "";

let access_token = localStorage.getItem("access_token") || null;
let refresh_token = getCookie("refresh_token");

const authInterceptor = axios.create({
  baseURL,
  headers: {
    Authorization: `Bearer ${access_token}`,
    "Content-Type": "application/json",
  },
});

authInterceptor.interceptors.request.use(async (req) => {
  if (!access_token) {
    access_token = localStorage.getItem("access_token") || null;
    req.headers.Authorization = `Bearer ${access_token}`;
  }

  const user = jwt_decode(access_token);
  const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;

  if (!isExpired) return req;

  const response = await axios.post(`${baseURL}/api/v1/auth/jwt/refresh/`, {
    refresh: refresh_token,
  });

  localStorage.setItem("access_token", response.data.access);
  access_token = response.data.access;
  req.headers.Authorization = `Bearer ${response.data.access}`;
  return req;
});

export { authInterceptor };